import { render, staticRenderFns } from "./tenatUsageAnalysis.vue?vue&type=template&id=61938e85&lang=pug"
import script from "./tenatUsageAnalysis.vue?vue&type=script&lang=js"
export * from "./tenatUsageAnalysis.vue?vue&type=script&lang=js"
import style0 from "./tenatUsageAnalysis.vue?vue&type=style&index=0&id=61938e85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports